import React from 'react';
import PropTypes from 'prop-types';
import { reduxForm } from 'redux-form';

import { compose } from 'redux';
import { Field } from 'redux-form';
import { connect } from 'react-redux';

import InputGroup from '../InputGroup';
import Button from '../Button';
import TwoGroup from '../TwoGroup';

import {
    AddressPopupContainer,
    Title,
    FormGroup,
    ButtonGroup
} from '../../containers/DefaultStyles/FormDetails';

import { LoadingSpinner } from '../../components/LoadingSpinner';

const validateEmptyField = value => {
    if (value == null || value === '') {
        return 'Invalid field';
    }
};

class ErrorForm extends React.Component {
    render() {
        return (
            <AddressPopupContainer onSubmit={this.props.handleSubmit} autocomplete="on">
                <Title>{this.props.message}</Title>
                <FormGroup>
                    <Field
                        name={this.props.name}
                        component={InputGroup}
                        type="text"
                        label={this.props.label}
                        autocomplete="off"
                        validate={validateEmptyField}
                    />
                </FormGroup>
                <ButtonGroup
                    isAddressSubmitting={this.props.isFormSubmitting}
                    rightPosition={50}
                >
                    <TwoGroup>
                        <Button
                            primary={true}
                            label={'Submit'}
                            type="submit"
                            className="submitButton"
                            disabled={this.props.invalid}
                        />
                        <LoadingSpinner />
                    </TwoGroup>
                </ButtonGroup>
            </AddressPopupContainer>
        );
    }
}

ErrorForm.propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    invalid: PropTypes.bool.isRequired,
    isFormSubmitting: PropTypes.bool,
    message: PropTypes.string,
    label: PropTypes.string,
    name: PropTypes.string
};

export default compose(
    connect(() => ({
        initialValues: {}
    })),
    reduxForm({
        form: 'errorForm',
        destroyOnUnmount: false
    })
)(ErrorForm);
